//import Swiper from "swiper"
import elementExists from "../utils/elementExists";
const HeroCarousel = () => {
		const carousels = document.querySelectorAll(".hero-carousel.has-slides")
		if( !elementExists( carousels, true ) ) return;
		carousels.forEach(function (element) {
			if (element.classList.contains("slider_started")) {
				return;
			}
			element.classList.add("slider_started");
			const id = element.getAttribute("id");
			const dataset = element.dataset;
			const autoplay = dataset.autoplay;
			const stopAutoplay = dataset.stopAutoplay;
			const delay = dataset.delay * 1000;
			const speed = dataset.speed * 1000;
			const showBullets = dataset.showBullets;
		
			let swiperParms = {
				parallax: dataset.parallax,
				effect: dataset.effect,
				speed: speed,
				loop: true,
				centeredSlides: false,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				autoplay:false
			};
			if( showBullets){
				swiperParms.pagination = 				 {
					el: `#${id} .swiper-pagination`,
					clickable: true,
					type: "bullets",
					renderBullet: function (index, className) {
						return (
							'<span class="' +
							className +
							'"><em>' +
							(index + 1) +
							'</em><i></i><b></b></span>'
						);
					},
				}
			}
			if (autoplay) {
				swiperParms.autoplay =  {
					delay: delay,
					pauseOnMouseEnter: false,
					disableOnInteraction: false,
					waitForTransition: true,
				}
			}

			const swiper = new Swiper(`#${id} .swiper`, swiperParms);
		
			swiper.on("slideChange", function () {
				element.style.setProperty("--bullet-duration", `${delay + speed}ms`);
			});
		
			swiper.on("beforeTransitionStart", function () {
				// colorScheme(this);
			});
		
			swiper.on("slideChange", function () {
				// colorScheme(this);
			});
		
			// function colorScheme(context) {
			// 	//const parent = context.el.parentElement;
			// 	const parent = element.querySelector(".slideshow-bottom");
			// 	const activeIndex = context.activeIndex;
			// 	const activeSlide = context.slides[activeIndex];
			// 	const changeItems = [parent];
			// 	const colorScheme = activeSlide.querySelector(".slideshow-slide").dataset.colorScheme;
		
			// 	changeItems.forEach(function (item) {
			// 		item.classList.forEach(function (className) {
			// 			if (/color-background-\d+$/.test(className)) {
			// 				item.classList.remove(className);
			// 			}
			// 		});
			// 		item.classList.add(colorScheme);
			// 	});
			// }
		});		
	};

export default HeroCarousel;